// helpers
import { format } from 'd3-format';
import { wrapLongLabels } from './utils/helpers';
import { cnn_red, defaults } from './utils/colors';

// styles
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    data,
    height,
    initialWidth,
    initialHeight,
    margins,
    x,
    xAxis,
    y,
    yAxis,
  } = props;

  const [min, max] = x.domain();

  const xTicks = isMobile ? 3 : 5;
  const comma = format(',');

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.right]})`);

  const xGrid = g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x).ticks(xTicks));

  xGrid.selectAll('text')
    .attr('y', 5);

  xGrid.selectAll('line')
    .attr('y2', -height);

  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y));

  yGrid.selectAll('text')
    .attr('transform', 'translate(-9,0)')
    .call(wrapLongLabels, margins.left);

  const bar = g.append('g')
    .attr('class', 'bars')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'bar')
    .attr('transform', d => `translate(${[x(Math.min(0, d.amt)), y(d.label)]})`);

  bar.append('rect')
    .attr('width', d => Math.abs(x(d.amt) - x(0)))
    .attr('height', y.bandwidth())
    .attr('fill', d => (d.amt == 1491 ? defaults.gray7 : cnn_red[0]));

  bar.append('text')
    .attr('transform', (d) => {
      const x0 = d.amt < 0 ? 5 : Math.abs(x(d.amt) - x(0)) + 5;
      const y0 = y.bandwidth() / 2;
      return `translate(${[x0, y0]})`;
    })
    .attr('text-anchor', d => ((d.value < 0 && Math.abs(d.value / min) < 0.85) || (d.value / max > 0.85) ? 'end' : 'start'))

    .attr('dy', '.35em')
    .text(d => `${comma(d.amt)}kg ${isMobile ? '' : 'CO₂'}`);

  const lines = g.append('g')
    .attr('class', 'lines');

  lines.append('line')
    .attr('x1', x(x.domain()[0]))
    .attr('x2', x(x.domain()[1]))
    .attr('y1', height)
    .attr('y2', height);

  // zero bar for negative values
  if (x.domain()[0] < 0) {
    lines.append('line')
      .attr('class', 'zero-bar')
      .attr('x1', x(0))
      .attr('x2', x(0))
      .attr('y2', height);
  }
}
